<template>
	<section class="not_found">
		<div class="container">

			<div class="content">

				<h1>Error 404</h1>

				<p class='subtitle'>The page you're searching for could not be found.</p>

				<p
					class="description"
					v-html="description"
				></p>

				<div class="cta_container">

					<primary-button
						@click.prevent="history.back()"
						v-if="parsedPrimary"
						:label="parsedPrimary.title"
						:link="parsedPrimary"
						theme='reverse'
					></primary-button>

					<secondary-button
						@click.prevent="history.back()"
						v-if="parsedSecondary"
						:label="parsedSecondary.title"
						:link="parsedSecondary"
						theme='reverse'
					></secondary-button>

				</div>

			</div>

		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';

export default {
	props: {
		title: {
			default: 'Error 404',
		},
		exp: {
			default: 'Page not found',
		},
		description: {
			default:
				'Looks like you’ve hit a dead-end, or the page you’re looking for might be under construction. Visit our homepage to get back on track or contact us for support.',
		},
		not_found_primary_cta: {},
		not_found_secondary_cta: {},
	},

	computed: {
		parsedPrimary() {
			if (this.not_found_primary_cta) {
				return JSON.parse(this.not_found_primary_cta);
			} else {
				return null;
			}
		},

		parsedSecondary() {
			if (this.not_found_secondary_cta) {
				return JSON.parse(this.not_found_secondary_cta);
			} else {
				return null;
			}
		},

		previousPage() {
			return {
				url: '/',
				target: '_self',
				title: 'Previous Page',
			};
		},

		homePage() {
			return {
				url: '/',
				target: '_self',
				title: 'Homepage',
			};
		},
	},

	watch: {},

	methods: {},

	components: {
		PrimaryButton,
		SecondaryButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.not_found {
	background: var(--rose);
	padding: 90px 0 90px;
	display: block;
	position: relative;
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		padding: 40px var(--gutter-mobile);
		// margin-bottom: 75px;
	}

	.container {
		position: relative;
		z-index: 25;
		align-content: center;

		@media (min-width: $mobile-xl) {
			max-width: 100%;
			padding: 0;
		}

		@media (max-width: $mobile-xl) {
			row-gap: 50px;
			padding: 0;
			margin: 0;
			width: 100%;
			max-width: 100%;
		}

		.content {
			display: flex;
			flex-direction: column;
			grid-column: 4 / span 6;
			justify-content: flex-end;
			align-items: center;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			img {
				width: 100px;
				margin: 0 auto;
			}

			h1 {
				color: var(--white);
				margin-top: 24px;
			}

			.subtitle {
				font: normal normal bold 20px/24px var(--primary-font-family);
				margin-top: 36px;
				color: var(--white);
				text-align: center;
			}

			.description {
				margin: 0 auto 0;
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
				text-align: center;
			}

			.cta_container {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				gap: var(--spacer);
				margin-top: 40px;

				@media (max-width: $mobile-xl) {
					margin-top: 20px;
				}
			}
		}
	}
}
</style>
